// ─── FEATURE FLAGS ───────────────────────────────────────────────────────────
// Central source of truth for feature flags so menu links and routes stay in sync.

// Set to true when the Midwives Reviewer (including its Study Guide) is ready to
// go live for subscribers. Controls both the sidebar menu item and the route.
export const SHOW_MIDWIVES_REVIEWER = true;

// Canonical list of Gulf licensure exams the midwifery reviewer covers. Add,
// remove, or rename an exam here and every page that lists exams stays in sync.
const MIDWIFERY_EXAMS = [
  { short: 'Prometric', full: 'Prometric', region: '' },
  { short: 'DHA', full: 'UAE DHA', region: 'Dubai' },
  { short: 'DHP', full: 'Qatar DHP', region: '' },
  { short: 'DOH', full: 'UAE DOH / HAAD', region: 'Abu Dhabi' },
  { short: 'NHRA', full: 'Bahrain NHRA', region: '' },
] as const;

// Builds a natural-language sentence list, e.g.
// "Prometric, UAE DHA (Dubai), ... , and Bahrain NHRA".
const examSentence = MIDWIFERY_EXAMS.map((e) =>
  e.region ? `${e.full} (${e.region})` : e.full,
).reduce((acc, name, i, arr) => {
  if (i === 0) return name;
  if (i === arr.length - 1) return `${acc}, and ${name}`;
  return `${acc}, ${name}`;
}, '');

// Single source of truth for the shared midwifery promo copy. Update a count,
// the exam list, or the alignment label here and every page stays in sync.
export const MIDWIFERY_PROMO = {
  questionCount: 1040,
  studyModuleCount: 12,
  alignmentLabel: 'WHO & ICM 2024 Aligned',
  exams: MIDWIFERY_EXAMS,
  // "Prometric · DHA · DHP · DOH · NHRA"
  examShortList: MIDWIFERY_EXAMS.map((e) => e.short).join(' · '),
  // ["Prometric", "UAE DHA", "Qatar DHP", "UAE DOH / HAAD", "Bahrain NHRA"]
  examFullList: MIDWIFERY_EXAMS.map((e) => e.full),
  examSentence,
  heading: 'Are you a Midwife?',
  description: (questionCount: number) =>
    `Get the Gulf Midwifery Reviewer — ${questionCount} questions, timed mock exams & full rationales.`,
} as const;
